module.exports = __webpack_public_path__ + "img/img-main-bg03M.33e5a3db.png";